import { Component, Inject, OnInit, OnDestroy } from '@angular/core'
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { Subscription } from 'rxjs'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatDivider } from '@angular/material/list'

export interface ConfirmationPopupDialogData {
  title: string
  subtitle?: string
  text: string
  useInnerHtml?: boolean
  skipTranslate?: boolean
}

@Component({
  selector: 'customer-portal-app-confirmation-popup',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDivider,
    MatDialogClose,
    MatIcon,
    MatDialogActions,
    MatButton,
    HubChildTranslateModule
  ],
  templateUrl: './confirmation-popup.component.html'
})
export class ConfirmationPopupComponent implements OnInit, OnDestroy {
  translatedTitle = ''
  translatedText = ''

  private languageChangeSub: Subscription

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationPopupDialogData,
    private readonly dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    private readonly transifexService: TransifexService
  ) {}

  ngOnInit (): void {
    this.languageChangeSub =
      this.transifexService.onTransifexLanguageChange.subscribe(() => {
        this.refreshLanguage()
      })
  }

  refreshLanguage (): void {
    this.translatedTitle = this.transifexService.getTranslation({
      key: this.data.title
    })

    if (this.data.skipTranslate === true) {
      this.translatedText = this.data.text
    } else {
      this.translatedText = this.transifexService.getTranslation({
        key: this.data.text
      })
    }
  }

  ngOnDestroy (): void {
    if (this.languageChangeSub) {
      this.languageChangeSub.unsubscribe()
    }
  }
}
